import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../style/Breadcrumbdasbord.css";

const Breadcrumbdasbord = ({
  title,
  items = [],
}) => {
  const location = useLocation();

  const getPageName = () => {
    if (title) return title;

    const path = location.pathname
      .split("/")
      .filter(Boolean)
      .pop();

    return path
      ? path
          .replace(/-/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase())
      : "Dashboard";
  };

  return (
    <div className="breadcrumb-dashboard">
      {/* LEFT TITLE */}
      <div className="breadcrumb-page-title">
        {getPageName()}
      </div>

      {/* RIGHT BREADCRUMB */}
      <div className="breadcrumb-right">
        <Link to="/" className="breadcrumb-home">
          Home
        </Link>

        {items.map((item, index) => (
          <React.Fragment key={index}>
            <span className="breadcrumb-slash">/</span>

            {item.path ? (
              <Link to={item.path} className="breadcrumb-link">
                {item.label}
              </Link>
            ) : (
              <span
                className={
                  index === items.length - 1
                    ? "breadcrumb-active"
                    : "breadcrumb-link"
                }
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
export default Breadcrumbdasbord;